import InterestListPageReducer from './InterestListPageReducer';

export default from './InterestListPageContainer';

export const InterestListPageReducers = {
  InterestListPageReducer,
};
